import React from "react";

/**фото для галлереи*/
import slide1 from "../images/Description/bany_chernay.webp";
import slide2 from "../images/Description/bany_ser.webp";
import slide3 from "../images/Description/bany_vid.webp";
import slide4 from "../images/Description/gamak.webp";
import slide5 from "../images/Description/pech-chern.webp";
import slide6 from "../images/Description/temperature.webp";
import slide7 from "../images/Description/razogrev.webp";
import slide8 from "../images/Description/parenie.webp";
import slide10 from "../images/Description/gostin1.webp";
import slide11 from "../images/Description/veniki.webp";
import slide12 from "../images/Description/gostin2.webp";
import slide13 from "../images/Description/gostin3.webp";
import slide14 from "../images/Chan/chan1.webp";
import slide15 from "../images/Chan/chan2.webp";
import slide16 from "../images/Chan/chan3.webp";
import slide17 from "../images/Description/pech-ser.webp";

/**Список положительных свойств*/
const positiveProps = [
  {
    id: 1,
    text: 'Ускорение процессов регенерации тканей.'
  },
  {
    id: 2,
    text: 'Питание клеток и насыщение их кислородом.'
  },
  {
    id: 3,
    text: 'Повышение общего иммунитета.'
  },
  {
    id: 4,
    text: 'Нормализация работы сердечно-сосудистой системы.'
  },
  {
    id: 5,
    text: 'Борьба с простудными и сезонными заболеваниями.'
  },
  {
    id: 6,
    text: 'Вывод токсинов и шлаков из организма.'
  },
  {
    id: 7,
    text: 'Нормализация обменных процессов, похудение.'
  }
]

const features =
  <div>
    <p>Основное отличие бань по-серому и по-чёрному заключается в конструкции печи.</p>
    <p>

      <strong>Печь бани по-чёрному, </strong>в классическом варианте, представляет собой открытый очаг
      над которым расположена решётка для камней. Камни нагреваются непосредственно
      пламенем. Дымоход в бане отсутствует, поэтому дым выходит через парную в двери,
      окна и специальные отверстия под потолком. Такая печь называется банная печь по-
      чёрному с открытой каменкой. Температура камней может достигать 700℃, что для
      открытого источника не совсем безопасно. В нашей бане по-чёрному, для безопасности,
      используется банная печь по-чёрному с закрытой каменкой и принципиально от банной
      печи по-серому не отличается.
    </p>
    <p>
      <strong>Печь в бане по-серому</strong> – это закрытый очаг, над которым расположена решётка с
      камнями. Нагрев камней происходит пламенем. В данной печи каменка закрыта и
      соединена с дымоходом, поэтому дым в парную не попадает, а уходит на улицу через
      трубу. Такая печь называется банная печь по-серому с закрытой каменкой. На камнях
      остаётся небольшое количество сажи и при плескании воды на камни сажа поднимается в
      воздух вместе с паром, поэтому в парной присутствует легкий «привкус» дыма.
    </p>
    <p>
      Данные конструктивные различия и определяют основные характеристики тепла и пара в парной.
    </p>
  </div>

const kindling =
  <div>
    <p>
      Печь – это «сердце» бани. В наших банях печи выложены из кирпича, состоят из трех
      отделений: поддувало, топка и каменок. Камни располагаются в каменке на специальной
      решётке над топкой и нагревается непосредственно огнём. В качестве камней
      используется нефрит. Он имеет отличные показатели теплоемкости и термостойкости.
    </p>
    <p>
      <strong>В бане по-чёрному</strong> установлена печь такая же, как и в бане по-серому. При растопке печи открывают дверцу каменка и закрывают дымоход, поэтому дым уходит на улицу через парную, оседая на стенах и стерилизуя парную.
    </p>
    <p>
      <strong>В бане по-серому</strong> при растопке дверцу каменка закрывают и дым в парную не попадает, а уходит на улицу через дымоход. Небольшое количество сажи оседает на камнях и при плескании водой на камни вместе с паром заполняет парную, создавая легкий аромат дыма.
    </p>
    <p>
      Топливом для бани являются дрова. Они максимально эффективны и безопасны. Для растопки в нашей бане используются березовые поленья. Жар, который дает береза, является дезинфицирующим для помещения и выделяет душистый аромат настоящей русской бани. Кроме этого, ему приписывают и лечебные свойства, которые помогают скорейшему выздоровлению во время простуды.
    </p>
    <p>
      Качество разогрева парилки напрямую зависит от времени года. Летом на хорошую растопку и нагрев бани может уйти до 3 часов непрерывного горения, а зимой от 5 до 6 часов, в зависимости от силы мороза.
    </p>
    <p>
      После растопки и нагрева бани, когда прогорят дрова, из печи удаляют золу и угли. Что
      бы из парной выветрились продукты горения – баню проветривают. При парении
      температура поддерживается только за счёт разогретой печи и камней в каменке.
    </p>
    <p>Теперь баня готова к парению!</p>
  </div>

const soaring =
  <div>
    <p>
      Перед посещением парной, не нужно  плотно наедаться или идти на пустой желудок. Достаточно что-нибудь съесть за 1,5 - 2 часа до похода в баню. Не нужно пользоваться кремами и макияжем, они могут закрыть поры. Заходить в парную лучше всего сухим. Обязательно следует одеть фетровую шапку. Не мочите голову перед  посещением парилки, влажные волосы увеличат риск теплового удара.
    </p>
    <p>
      При первом заходе в парной не должно быть слишком жарко, тело должно привыкнуть к температуре. Поэтому лучше не ложиться сразу на верхнюю полку, а некоторое время провести на нижней полке.
    </p>
    <p>
      Под воздействием жара температура кожи тела  увеличивается. При этом наблюдается усиление кровообращения в коже. В  первые 2 минуты пребывания в парной – температура кожи повышается значительно,  затем в связи с включением терморегуляторных механизмов и началом  потоотделения повышение температуры замедляется. Первое пребывание в парной не должно продолжаться более 10  минут.
    </p>
    <p>
      Во время второго и последующих визитов можно начинать подниматься выше нижней полки, повышать температуру в парной и использовать банный веник.
    </p>
    <p>
      Последний заход. Как только вошли, сразу можно усилить пар и жар. Повышение
      температуры и влажности не должно быть чрезмерным, иначе будет трудно дышать.
      Оптимальные показатели термогигрометра – соотношение 25 ÷ 40% и 65 ÷ 100℃.
    </p>
    <p>
      Рекомендуемое количество заходов от – двух до четырёх, продолжительностью каждого не более 10-15 минут. Отдых между заходами, для восстановления сердечно-сосудистой системы, должен составлять не менее 15-25 минут.
    </p>
    <p className="alert-text">
      <em>
        Обратите внимание, что парение в положении стоя приводит к задержке крови в
        нижних конечностях, и увеличивает риск обморока в парной или по выходу из нее.
        Особенно вредно парение в положении стоя или с опущенными ногами для лиц с
        заболеваниями вен нижних конечностей и с хронической сердечной недостаточностью.
      </em>
    </p>
    <strong style={{display: 'block', marginBottom: '20px'}}>Рекомендуем воспользоваться услугами профессионального парильщика.
      Вам предложат разные виды парения и позаботятся о вашем здоровье.</strong>
  </div>

const about =
  <div>
    <p>
      Баня расположена в живописном экологически чистом районе на берегу реки Оби. Сруб собран без единого гвоздя по технологии наших предков. В бане по-чёрному сруб собран из сосны, а в бане по-серому – из осины. Баня отапливается современной русской печью из кирпича. В каменке, в качестве камней используется нефрит.
    </p>
    <p>
      В бане созданы все условия для комфорта. В ней размещаются: санузел, просторная комната отдыха с деревянной мебелью, душ и сама парная. В комнате  отдыха коротают время между посещениями  парной, общаются с друзьями, пьют чай или квас. Дополнительно можно заказать: безалкогольные напитки и банное меню, взять одноразовые тапочки, полотенца, простыни, "шапки-будёновки", использовать ароматические масла, берёзовые веники и насладиться чаем с мёдом, а также воспользоваться услугами профессионального парильщика и попробовать различные программы парения. В летний период можно окунуться в реке, а зимой – в проруби, можно выйти на террасу с видом на реку.
    </p>
  </div>

export const chan =
  <div>
    <p>
      Банный чан представляет собой большую чашу, изготовленную из металла. Внутри
      емкость обшита деревом. Установлен он на улице возле бани. Принимать ванны в чане
      можно круглый год. Вода подогревается печью на дровах до 35-45 градусов в
      зависимости от температуры воздуха.
    </p>
    <p>
      Для улучшения целебных свойств при принятии ванн в воду добавляют ветки хвойных
      деревьев. Хвоя богата витаминами, минералами, микроэлементами, дубильными
      веществами. Она оказывает благотворное воздействие на все системы организма.
    </p>
    <p>К положительным свойствам хвойных ванн относятся :</p>
    <ul className="description-list">
      {
        positiveProps.map((positive) => (
          <li key={positive.id} className="description-item">{positive.text}</li>
        ))
      }
    </ul>
    <p>Список можно продолжать и дальше. Поэтому банный чан так популярен.</p>
  </div>
export const chanGallery = [
  {
    id: 1,
    src: slide14,
    alt: 'Банный чан зимой'
  },
  {
    id: 2,
    src: slide15,
    alt: 'Банный чан летом'
  },
  {
    id: 3,
    src: slide16,
    alt: 'Банный чан, девушки'
  }
]


export const descriptionBanya = [
  {
    id: 1,
    title: 'Особенности',
    desc: features,
    gallery: [
      {
        id: 1,
        src: slide1,
        alt: 'Баня по-черному'
      },
      {
        id: 2,
        src: slide2,
        alt: 'Баня по-серому'
      },
      {
        id: 3,
        src: slide3,
        alt: 'Баня по-черному вид с реки'
      },
      {
        id: 4,
        src: slide4,
        alt: 'Топчаны'
      },
    ]
  },
  {
    id: 2,
    title: 'Растопка',
    desc: kindling,
    gallery: [
      {
        id: 1,
        src: slide5,
        alt: 'Печь бани по серому'
      },
      {
        id: 2,
        src: slide6,
        alt: 'Растопка для бани по черному'
      },
      {
        id: 3,
        src: slide17,
        alt: 'Печь бани по-черному'
      },
    ]
  },
  {
    id: 3,
    title: 'Парение',
    desc: soaring,
    gallery: [
      {
        id: 1,
        src: slide8,
        alt: 'Парение дубовым веником'
      },
      {
        id: 2,
        src: slide7,
        alt: 'Парение в бане по черному'
      },
    ]
  },
  {
    id: 4,
    title: 'Описание',
    desc: about,
    gallery: [
      {
        id: 1,
        src: slide10,
        alt: 'Баня по-серому. Предбанник'
      },
      {
        id: 2,
        src: slide11,
        alt: 'Баня по-серому. Девушки'
      },
      {
        id: 3,
        src: slide12,
        alt: 'Баня по-серому. Зона отдыха'
      },
      {
        id: 4,
        src: slide13,
        alt: 'Баня по-серому. Парная'
      },
    ]
  },
]